import { Component, Input, OnInit, Optional } from '@angular/core';
import { AccordionsComponent } from '../accordions.component';

@Component({
  selector: 'zen-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent implements OnInit {
  @Input()
  active: boolean = false;
  @Input() extraClasses;
  @Input()
  title: string;

  constructor(@Optional() private accordions: AccordionsComponent) { }

  ngOnInit(): void {
  }

  clicked() {
    if (this.accordions) {
      if (this.active)
        this.accordions.deselectTab(this);
      else
        this.accordions.selectTab(this);
    }
    else this.active = !this.active

  }

}


